import { Component, OnInit } from '@angular/core';
import { CreditsService } from '../../state/credits.service';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';

interface DashboardItem {
    header?: string;
    detail?: string | number;
    entity?: string;
}

@Component({
    selector: 'sb-credits-dashboard',
    templateUrl: './sb-credits-dashboard.component.html',
    styleUrls: ['./sb-credits-dashboard.component.scss']
})
export class SbCreditsDashboardComponent implements OnInit {
    public title = 'Financing';
    public isNoData: boolean = false;
    public isLoading: boolean = true;
    public isError: boolean = false;
    public rows;

    constructor(private creditsService: CreditsService, private router: Router) {}

    ngOnInit() {
        this.creditsService
            .getKeyMetricsForDashboard()
            .pipe(
                catchError((error) => {
                    console.error('Error fetching credits dashboard data:', error);
                    this.isError = true;
                    this.isLoading = false;
                    return of([]);
                })
            )
            .subscribe((response) => this.parseCreditsKeyMetrics(response));
    }

    parseCreditsKeyMetrics(response) {
        if (response?.results) {
            this.rows = [];
            for (let [key, value] of Object.entries(response.results)) {
                this.rows.push(value);
            }
        } else {
            this.isNoData = true;
        }

        this.isLoading = false;
    }

    formatNumber(numberString: string): string {
        return numberString.toLocaleString();
    }

    navigateToCreditPage() {
        this.router.navigate(['/credits']);
    }
}
